export const FREE_TEXT_COPY = {
  placeholder: 'Write your answer here',
};
